module.exports = __webpack_public_path__ + "static/images/capacity.625029acd9a5816175d44361353c89a6.svg";